<template>
	<div class="module_course">

		<course-header-s-r :course-id="course.uuid" :disableTOC="true" class="header_assessment_learn"></course-header-s-r>

		<div class="row page-content" :class="isTocOpen ? 'toc_activated' : ''">
			<div class="col-12 assessment-learn can_full_screen">

				<div class="header">
					<template v-if="!islocalPracticeReviewLoaded">
                        <b-link class="icon-home" :to="{ name: 'clearlyNextStudentDashboard'}" style="margin: 9px 35px 0px 2px;"></b-link>
                    </template>
					<div v-if="entity.fileType === 'assessment' && islocalPracticeReviewLoaded" class="icon icon-assessment"></div>
					<div class="heading">{{entity.title}}</div>
					<div class="btn_container">
                        <template v-if="islocalPracticeReviewLoaded">
                            <b-button @click="done(course.uuid, entity.objectType, entity.uuid)" class="btn button-primary next"> Done </b-button>
                        </template>
                        <template v-if="careerIdeaId">
                            <b-button @click="goBackToConnections" class="btn button-primary mr-3" style="padding: 5px 10px !important;"> return to career idea </b-button>
                        </template>
          			</div>
				</div>

				<div v-if="loadLaunchAssessmentWidget" class="assessment-container">
					<template v-if="myattempts.length > 0">
                        <template v-if="attempt.isResume">
                            <quest-launch-assessment :uuid="entityUuid" :course-id="uuid" :session-id="assessment.sessionId" :can-edit="false" :career-idea-id="careerIdeaId" @localPracticeReviewLoaded="showDoneButton"></quest-launch-assessment>
                        </template>
                        <template v-else>
                            <quest-launch-assessment :uuid="entityUuid" :course-id="uuid" :session-id="attempt.sessionId" :can-edit="true" :career-idea-id="careerIdeaId" @localPracticeReviewLoaded="showDoneButton"></quest-launch-assessment>
                        </template>
					</template>
					<template v-else>
                        <quest-launch-assessment :uuid="entityUuid" :course-id="uuid" :session-id="assessment.sessionId" :can-edit="false" :career-idea-id="careerIdeaId" @localPracticeReviewLoaded="showDoneButton"></quest-launch-assessment>
					</template>
            	</div>

			</div>
		</div>

	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import CourseHeaderSR from './CourseHeaderSR'
import QuestLaunchAssessment from '../../assessment/components/QuestLaunchAssessment'

export default {
  name: 'quest-learn',
  props: ['uuid', 'entityType', 'entityUuid', 'careerIdeaId'],
  components: {
    CourseHeaderSR,
    QuestLaunchAssessment
  },
  data: () => {
    return {
      attempt: {},
      myattempts: [],
      assessment: {},
      loadLaunchAssessmentWidget: false,
      islocalPracticeReviewLoaded: false
    }
  },

  mounted () {
    this.loadCourse()
  },

  methods: {
    ...mapActions([
      'loadCourseDetail',
      'loadEntityDetail',
      'loadAssessment2',
      'startActivity'
    ]),

    loadCourse () {
      this.$store.commit('LOAD_COURSE', {})
      this.$store.commit('LOAD_ENTITY_DETAIL', {})
      this.loadCourseDetail(this.uuid)
      this.loadAssessment2({uuid: this.entityUuid}).then((response) => {
        const data = { ...response }
        this.myattempts = data.attempt
        this.assessment = data.assessment
        if (this.myattempts && this.myattempts.length > 0) {
          this.attempt = this.myattempts[this.myattempts.length - 1]
        }
        const entityDetailInfo = {
          'entityType': this.entityType,
          'entityUuid': this.entityUuid
        }
        this.loadEntityDetail(entityDetailInfo).then((res) => {
          if (res && res.type === 'ASSESSMENT') {
            this.loadLaunchAssessmentWidget = true
          }
        })
      })
      var startActivity = {
        'userId': localStorage.getItem('userid'),
        'entityUuid': this.entityUuid
      }
      this.startActivity(startActivity)
      $('.can_full_screen').addClass('full_screen')
    },

    showDoneButton (value) {
      this.islocalPracticeReviewLoaded = value
    },

    done (uuid, entityType, entityUuid) {
      this.$router.push({ name: 'entityDetailSR', params: { uuid: uuid, entityType: entityType, entityUuid: entityUuid } })
    },

    goBackToConnections () {
      return this.$router.push({name: 'connection', params: {careerIdeaId: this.careerIdeaId}})
    }
  },

  computed: {
    ...mapState({
      'course': state => state.course.course,
			'isTocOpen': state => state.course.isTocOpen,
      'entity': state => state.course.entity
    })
  },

  watch: {
    entityUuid (newId) {
      if (newId) {
        this.loadCourse()
      }
    }
  }
}
</script>

<style scoped>
    .header {
    	background: #f7e5a8;
    	margin-bottom: 30px;
    	float: left;
        width: 100%;
    	padding-left: 20px;
    	height:62px;
    }
    .icon-home {
        font-size: 44px;
        float: left;
        color: #157099;
    }

    .heading {
    	float: left;
    	font-size: 20px;
    	margin-top: 17px;
    	color: rgb(79, 79, 79);
    	font-family: robotoSlab_Light;
    	max-width: calc(100% - 138px);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .btn_container {
    	float: right;
        margin: 12px 20px;
    }

    .container {
    	width: 90%;
    	max-width: 90%;
    	margin-left: 5%;
    	height: 98%;
    }

    .container iframe {
    	width: 90% !important;
    	margin-left: 5%;
    	height: 95%;
    }

    .assessment-container {
    	padding-left: 5%;
    	width: 95%;
    }
</style>



// WEBPACK FOOTER //
// src/app/course/components/QuestLearn.vue